import * as condition from '../services/condition';

export default {
  namespace: 'condition',

  state: {
    getOutputList: null,
    editOutputList: null,
    deleteOutputList: null,
    getRuleList: null,
    addOutputList: null,
    deleteRuleList: null,
    saveMultipleRuleList: null,
    deleteMulRuleList: null,
  },

  effects: {
    *getOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.getOutputList, values);
      yield put({
        type: 'save',
        payload: {
          getOutputList: response,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    *editOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.editOutputList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editOutputList: response,
        },
      });
    },
    *addOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.addOutputList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addOutputList: response,
        },
      });
    },
    *deleteOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.deleteOutputList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteOutputList: response,
        },
      });
    },
    *getRuleList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(condition.getRuleList, values);
      yield put({
        type: 'save',
        payload: {
          getRuleList: response,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *saveRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.saveRuleList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveRuleList: response,
        },
      });
    },
    *saveMultipleRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        condition.saveMultipleRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveMultipleRuleList: response,
        },
      });
    },
    *deleteRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(condition.deleteRuleList, values);

      yield put({
        type: 'save',
        payload: {
          deleteRuleList: response,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *deleteMulRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        condition.deleteMulRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteMulRuleList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
